import __request__ from 'routing/request';
interface MitreCategoriesResource__MitreTactic {
    readonly techniques: MitreCategoriesResource__MitreTechnique[];
    readonly name: string;
    readonly id: string;
}
interface MitreCategoriesResource__MitreCategories {
    readonly tactics: MitreCategoriesResource__MitreTactic[];
}
interface MitreCategoriesResource__MitreTechnique {
    readonly name: string;
    readonly id: string;
    readonly subtechniques: MitreCategoriesResource__MitreSubTechnique[];
}
interface MitreCategoriesResource__MitreSubTechnique {
    readonly name: string;
    readonly id: string;
}
/**
 * Get list of Mitre tactic/techiques with resolved names
 */
export function categories(): Promise<MitreCategoriesResource__MitreCategories> {
    return __request__('GET', '/plugins/org.graylog.plugins.securityapp/mitre_categories', null, {}, {
        'Accept': ['application/json']
    });
}
